import { IComposableChartsWidget } from 'wisestep-api';

import { FreeTextEditor } from '../';

export const enum Index {
  FREE_TEXT_WIDGET = 'free_text_widget',
}

export const freeTextWidgetKeys: IComposableChartsWidget[] = [
  {
    name: 'Free Text Widget',
    component: FreeTextEditor,
    category: 'freeTextWidget',
    type: Index.FREE_TEXT_WIDGET,
    filters: '',
  },
];
